import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import TaskList from "./components/TaskList/TaskList";
import CreateTask from "./components/CreateTask/CreateTask";
import LoginPage from "./components/LoginPage/LoginPage";
import Unauthorized from "./components/Unauthorized";

function App() {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const hideSidebar = location.pathname === "/" || location.pathname === "/unauthorized" || !token;

  return (
    <div className="App" style={{ display: "flex" }}>
      {!hideSidebar && <Sidebar />}
      <div style={{ marginLeft: hideSidebar ? "0px" : "220px", flex: 1 }}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/create-book" element={<CreateTask />} />
          <Route path="/book-list" element={<TaskList />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
